import React, { memo } from 'react';
import FormElementWrapper from '../components/FormElementWrapper';
import { youTubeLinkRegExp } from '../defaults/validation';

const Video = props => {
  const { videoLink } = props.data;

  const isLinkCorrect = !!videoLink && videoLink.match(youTubeLinkRegExp);

  const adaptedVideoLink =
    isLinkCorrect && `https://www.youtube.com/embed/${new URL(videoLink).searchParams.get('v')}`;
  return (
    <FormElementWrapper {...props}>
      {(!videoLink || !isLinkCorrect) && (
        <div className="p-6 flex justify-center items-center">
          {!videoLink ? 'No link provided' : 'Incorrect link provided'}
        </div>
      )}
      {videoLink && isLinkCorrect && (
        <iframe
          className="w-full"
          style={{ aspectRatio: 1, borderRadius: 8 }}
          src={adaptedVideoLink}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        ></iframe>
      )}
    </FormElementWrapper>
  );
};

export default memo(Video);
